module.exports = __webpack_public_path__ + "static/media/logo_shinhanbank.cf506f12.svg";